import { useCallback, useState } from 'react';

import { defaultOptions } from './constants';

const useSort = options => {
  const [order, setOrder] = useState({ ...defaultOptions, ...options });

  const onRequestSort = useCallback(
    e => {
      const { id } = e.currentTarget.dataset;

      const direction = order.id === id && order.direction === 'desc' ? 'asc' : 'desc';

      setOrder({
        direction,
        id,
      });
    },
    [order],
  );

  const resetSort = useCallback(() => {
    setOrder({
      ...defaultOptions,
      ...options,
    });
  }, [options]);

  return {
    order,
    onRequestSort,
    resetSort,
  };
};

export default useSort;
